import React from 'react';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import { Anchor, Flag } from '../../common';
import { getTypeIcon } from '../FlagContext/flag-utils';
import { GENERIC_ERROR_FLAG_ID } from '../../constants';
import GenericErrorFlag from './GenericErrorFlag';
import { FlagType } from '../FlagContext/types';

type ProcessedFlag = Flag & {
  icon?: JSX.Element;
};

interface Props {
  flags: ProcessedFlag[];
  removeFlag: (flagId: string) => void;
}

const Flags = ({ flags, removeFlag }: Props) => {
  const flagsInGroup = flags.map((flagProps, index) => {
    const {
      id,
      type,
      icon,
      appearance,
      title,
      description,
      links = [],
      actions,
    } = flagProps;

    // id alone doesn't guarantee uniqueness, as 'flags'/notifications with the same id
    // may be added multiple times
    const key = `${id}_${index}`;

    if (typeof id === 'string' && id.startsWith(GENERIC_ERROR_FLAG_ID)) {
      return <GenericErrorFlag key={key + '_GENERIC'} id={id} />;
    }

    // we cannot get props type of AutoDismissFlag so we have to use any here
    // tslint:disable-next-line:no-any
    const flagComponentProps: any = {
      id,
      icon: icon || getTypeIcon(type || (appearance as FlagType)),
      title,
      description,
      appearance,
      actions:
        actions ||
        links.map(({ text, ...props }) => ({
          content: <Anchor {...props}>{text}</Anchor>,
        })),
    };

    return <AutoDismissFlag key={key} {...flagComponentProps} />;
  });

  return <FlagGroup onDismissed={removeFlag}>{flagsInGroup}</FlagGroup>;
};

export default Flags;
